import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CodeInputModule } from "angular-code-input";
import { QRCodeModule } from "angularx-qrcode";

import { AWSHttpModule } from "@intocare/aws";
import { CoreModule } from "@intocare/core";
import { FormsDirectivesModule } from "@intocare/forms";
import { LanguageModule, LanguagePipe, TranslationLoaderResolver } from "@intocare/language";
import { PipesModule } from "@intocare/pipes";
import { UIModule } from "@intocare/ui";

import { AuthWrapperComponent } from "./components/auth-wrapper/auth-wrapper.component";
import { ConfirmPasswordFormComponent } from "./components/confirm-password-form/confirm-password.component";
import { LoginFormComponent } from "./components/login-form/login-form.component";
import { MfaLoginFormComponent } from "./components/mfa-login-form/mfa-login-form.component";
import { OrganisationFormComponent } from "./components/organisation-form/organisation-form.component";
import { TermsAndConditionsComponent } from "./components/terms-conditions/terms-conditions.component";
import { TermsAndConditionsTextComponent } from "./components/terms-conditions-text/terms-conditions-text.component";
import {
	MFAComponent,
	MustSetMainFunctionProblemComponent,
	ProblemComponent,
	UnknownProblemComponent,
} from "./containers";
import { ConfirmComponent } from "./containers/confirm/confirm.component";
import { MfaSetupComponent } from "./containers/mfa-setup/mfa-setup.component";
import { NoPermissionsComponent } from "./containers/no-permissions/no-permissions.component";
import { SelectOrganisationComponent } from "./containers/select-organisation/select-organisation.component";
import { SignInComponent } from "./containers/sign-in/sign-in.component";
import { SignInWithUsernameComponent } from "./containers/sign-in-with-username/sign-in-with-username.component";
import { directives } from "./directives";

export function windowFactory() {
	return window;
}

@NgModule({
	imports: [
		AWSHttpModule,
		TranslateModule,
		UIModule,
		CommonModule,
		FormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		FormsDirectivesModule,
		LanguageModule,
		PipesModule,
		TranslateModule.forChild(),
		QRCodeModule,
		CodeInputModule,
		CoreModule,
		...directives,
	],
	providers: [LanguagePipe, TranslationLoaderResolver],
	declarations: [
		NoPermissionsComponent,
		SignInWithUsernameComponent,
		MfaSetupComponent,
		LoginFormComponent,
		ConfirmComponent,
		ConfirmPasswordFormComponent,
		AuthWrapperComponent,
		MFAComponent,
		MfaLoginFormComponent,
		TermsAndConditionsComponent,
		TermsAndConditionsTextComponent,
		OrganisationFormComponent,
		SelectOrganisationComponent,
		SignInComponent,
		ProblemComponent,
		UnknownProblemComponent,
		MustSetMainFunctionProblemComponent,
	],
	exports: [
		NoPermissionsComponent,
		SignInWithUsernameComponent,
		MfaSetupComponent,
		LoginFormComponent,
		ConfirmComponent,
		ConfirmPasswordFormComponent,
		AuthWrapperComponent,
		TermsAndConditionsComponent,
		TermsAndConditionsTextComponent,
		...directives,
		SelectOrganisationComponent,
		SignInComponent,
		ProblemComponent,
		UnknownProblemComponent,
		MustSetMainFunctionProblemComponent,
	],
})
export class AuthModule {}
